/* global mainScript */
import { useState, useEffect } from "react";
import axios from "axios";
import moment from "moment";

import CalendarEventForm from "./CalendarEventForm";
import Loader from "../Helpers/Loader";

const CalendarEvent = ({event, date, apiKey, today}) => {

	const [formOpen, setFormOpen] = useState(false);
	const [formData, setFormData] = useState({});
	const [audioguideFormData, setAudioguideFormData] = useState({});
	const [ticketNumber, setTicketNumber] = useState(0);
	const [audioguide, setAudioguide] = useState(0);
	const [showLoader, setShowLoader] = useState(false);

	useEffect(() => {

		if (ticketNumber < audioguide) {
			setAudioguide(ticketNumber)
		}

	}, [ticketNumber])

	useEffect(() => {

		setFormData({
			sessionId: apiKey,
			priceType: event.price_type,
			performanceId: event.performance_id,
			number: ticketNumber,
			zoneId: event.zone_id,
		})

		if (event.ag_availability > 0) {
			setAudioguideFormData({
				sessionId: apiKey,
				priceType: event.ag_price_type,
				performanceId: event.ag_performance_id,
				number: audioguide,
				zoneId: event.zone_id
			})
		}


	}, [ticketNumber, audioguide, apiKey])

	const handleSubmit = (e) => {

		e.preventDefault();

		if (event.type === 'hsv') {
			axios
				.post(`/wp-json/fords/v1/cart/add`, {
					...formData
				})
				.then((res) => {
					if (audioguide > 0) {
						axios
							.post(`/wp-json/fords/v1/cart/add`, {
								...audioguideFormData
							})
							.then((res) => {
								setShowLoader(true)
								window.location.href = mainScript.tnewRedirectUrl;
								// have to do set timeout in case user travels back in browser history because it keeps the state so would show loader spinning
								setTimeout(() => {
									setShowLoader(false)
								}, 1000);
							})
					} else {
						setShowLoader(true);
						window.location.href = mainScript.tnewRedirectUrl;
						// have to do set timeout in case user travels back in browser history because it keeps the state so would show loader spinning
						setTimeout(() => {
							setShowLoader(false);
						}, 1000);
					}
				})
		} else {
			return window.open(event.url, "_blank");
		}
	}

	const handleButtonClick = (e) => {
		e.preventDefault();

		if (event.type === 'hsv' && date !== today) {
			setFormOpen(true);
		} else if (event.type === "hsv" && date === today) {
			return window.open("/visit-us/historic-site-visit/#options", "_blank");
		} else {
			return window.open(event.url, "_blank");
		}
	}

	const displayButtonText = () => {

		if (date < today || event.availability === 0) {
			return "Sold Out"
		}

		if (event.type === "hsv" && date === today) {
			return "Contact Box Office"
		}

		if (event.button_label !== false) {
			return event.button_label
		}

		return "Buy Tickets"
	}

	return (
		<div className="event" key={event.id}>
			<form onSubmit={handleSubmit}>
				<div className="event__wrap">
					<div className="event__time-duration">
						<div className="event__time-price">
							<time dateTime={moment(date + " " + event.time).format("h:mm A")}>
								<h4>{moment(date + " " + event.time).format("h:mm A")}</h4>
							</time>
							<div className="event__price">
								<span>{event.price}</span>
							</div>
						</div>
					</div>

					<div className="event__info">
						<div className="event__title">
							<h4 dangerouslySetInnerHTML={{ __html: event.title }}></h4>
						</div>
						<div className="event__locations">
							{/* regex is to remove colons and spaces in the location strings */}
							{event.locations.map((location) => (
								<span key={location} className={"location " + location.replace(/\s|:/g, "")}>
									{location}
								</span>
							))}
						</div>
						<div className="event__description">
							<p>
								<i dangerouslySetInnerHTML={{__html: event.message}}></i>
							</p>
						</div>
					</div>


					<div className="event__button">
						{event.url &&
							<button disabled={date < today || event.availability === 0} onClick={(e) => handleButtonClick(e)}>
								{displayButtonText()}
							</button>
						}
						{!event.title.toLowerCase().startsWith("history on foot") && event.availability < 20 && event.availability > 0 && event.url && <span>Low availability</span>}
					</div>

					{formOpen === true && <CalendarEventForm date={date} event={event} setFormOpen={setFormOpen} ticketNumber={ticketNumber} setTicketNumber={setTicketNumber} audioguide={audioguide} setAudioguide={setAudioguide} />}
				</div>
			</form>
			{showLoader && <Loader/>}
		</div>
	);
}

export default CalendarEvent;
